module.exports = __webpack_public_path__ + "static/media/actorTypesDefaultImage.03cc36f3.jpg";